module.exports = __webpack_public_path__ + "a17d279f/img/rename-icon.de4e673d.svg";